export default __webpack_public_path__ + "static/media/quiz-pro.08587e23.png";